
function countWords ({
  area = 'textarea',
  out = 'label',
  max = 100
} = {}) {

  function countWordsIn(text) {
    var n = 0;
    for (var i = 0; i < text.length; i++) {
        if (text[i] == " ") n += 1;
    }
    return n + 1
  }

  function updateOutput() {
    const n = countWordsIn(document.getElementById(area).value)
    document.getElementById(out).innerHTML = `${max - n} words left`;
  }

  const textarea = document.getElementById(area)
  const output = document.getElementById(out)
  if (textarea !== null && output !== null ) {
    updateOutput();
    textarea.addEventListener('keyup', updateOutput);
  }
}

function attachCounters() {
    // these counters are only present on the contact form page..
  countWords({area: 'text1', out: 'counter1', max: 300});
  countWords({area: 'text2', out: 'counter2', max: 300});
  countWords({area: 'text3', out: 'counter3', max: 500});
  countWords({area: 'text4', out: 'counter4', max: 500});
}

window.addEventListener('load', function () {
    attachCounters();
}, false);
